import { isMobile } from 'react-device-detect';
import { env } from 'env';
import WebcamSharingButton from './WebcamSharing';

import { useConference } from '../../DashboardContent/Dolby';
import { useMytaverseEvent } from '../../../providers';
import { useModal } from '@hooks/modal';
import { useShowInitialMuteModal } from './hooks';
import { useMytaverse } from '@providers/MytaverseProvider';

import MicButton from '@core/dashboard/components/HomeBottomBar/MicButton';
import ScreenShareButton from '@core/dashboard/components/HomeBottomBar/ScreenShareButton';
import RaiseHandButton from '@core/dashboard/components/HomeBottomBar/RaiseHandButton';
import PersonViewToggleButton from '../PersonViewToggleButton';
import TrainerTools from '@features/TrainerTools';
import ParticipantScopes from '@constants/scopes';
import {
  useClientSpecificCameraVisibility,
  useClientSpecificMicVisibility,
} from '@hooks/clientSpecificUtils';

const HomeBottomButtonOptions = () => {
  const { REACT_APP_CLASSROOM_EVENT_TAGS } = env;
  const CLASSROOM_TAGS = (REACT_APP_CLASSROOM_EVENT_TAGS || '')
    .split(',')
    .map((t) => t.toLowerCase().trim());

  const { isCameraEnabled } = useClientSpecificCameraVisibility();
  const { isMicEnabled } = useClientSpecificMicVisibility();

  const { ueScreenScreenName } = useConference();
  const { userPermissions } = useMytaverse();
  const {
    currentEvent,
    canSpeak,
    canShowCamera,
    canShareCamera,
    canShareScreen,
    currentParticipant,
  } = useMytaverseEvent();

  const initialMuteModalData = useModal();

  useShowInitialMuteModal({
    eventId: currentEvent?.eventId || '',
    initialMuteModalData,
  });

  const isTrainer = userPermissions?.includes(
    ParticipantScopes.HubTrainingToolHubEvent,
  );
  // Check if current event is a classroom event
  const eventTags = currentEvent?.eventTags ?? [];
  const isClassroomEvent = eventTags.some(
    (tag) =>
      typeof tag === 'string' && CLASSROOM_TAGS.includes(tag.toLowerCase()),
  );

  // Determine visibility
  const showTrainerTools = isClassroomEvent && isTrainer;
  const showRaiseHandButton = isClassroomEvent && !isTrainer;

  const isSeatRegion = currentParticipant?.isSeatRegion;

  return (
    <>
      {canSpeak ? (
        <>
          {isCameraEnabled && (canShowCamera || canShareCamera) && !isSeatRegion ? (
            <WebcamSharingButton />
          ) : null}

          {isMicEnabled ? <MicButton /> : null}

          {canShareScreen &&
          !isMobile &&
          ueScreenScreenName &&
          !showTrainerTools ? (
            <ScreenShareButton />
          ) : null}
        </>
      ) : null}

      {showRaiseHandButton && <RaiseHandButton />}
      <PersonViewToggleButton />
      {showTrainerTools && <TrainerTools />}
    </>
  );
};

export default HomeBottomButtonOptions;
